<template>
    <div>
        freightClassification
    </div>
</template>

<script>
    export default {
        name: 'freightClassification',
    }
</script>

<style lang="scss" scoped>

</style>